import script from "./Dept.vue?vue&type=script&setup=true&lang=js"
export * from "./Dept.vue?vue&type=script&setup=true&lang=js"

import "./Dept.vue?vue&type=style&index=0&id=d4766284&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4766284"]])

export default __exports__